<template>
  <div>
    <footer class="section-footer border-top bg-dark">
      <div class="container">
        <section class="footer-top padding-y py-5">
          <div class="row pt-3">
            <aside class="col-md-6 footer-about">
              <article class="d-flex pb-3 text-left">
                <div>
                  <img
                    alt="#"
                    :src="
                      `${
                        restaurant.logo
                          ? 'https://space.monresto.menu/logos/' +
                            restaurant.logo
                          : 'https://space.monresto.menu/logos/logo.png'
                      }`
                    "
                    class="logo-footer mr-3"
                  />
                </div>
                <div>
                  <h6 class="title text-white">À propos de nous</h6>
                  <p
                    class="text-muted"
                    style="
                            padding-right: 2em;
                        "
                  >
                    {{ restaurant.observation }}
                  </p>
                  <div class="d-flex align-items-center">
                    <a
                      class="btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Facebook"
                      target="_blank"
                      href="#"
                      ><i class="feather-facebook"></i
                    ></a>
                    <a
                      class="btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Instagram"
                      target="_blank"
                      href="#"
                      ><i class="feather-instagram"></i
                    ></a>
                    <a
                      class="btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Youtube"
                      target="_blank"
                      href="#"
                      ><i class="feather-youtube"></i
                    ></a>
                    <a
                      class="btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Twitter"
                      target="_blank"
                      href="#"
                      ><i class="feather-twitter"></i
                    ></a>
                  </div>
                </div>
              </article>
            </aside>
            <aside class="col-sm-3 col-md-3 text-white text-left">
              <h6 class="title">Nous Contacter</h6>
              <ul class="list-unstyled hov_footer">
                <li class="liContacts mb-3">
                  <a href="" class="text-muted">
                    <a
                      class="footer-contact btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Phone"
                      target="_blank"
                      href="#"
                      ><i class="feather-phone"></i> </a
                    ><span class="text-muted" style="font-size:12px;">{{
                      restaurant.phone
                    }}</span></a
                  >
                </li>
                <li class="liContacts mb-3">
                  <a href="" class="text-muted"
                    ><a
                      class="footer-contact btn btn-icon btn-outline-light mr-1 btn-sm"
                      title="Adresse"
                      target="_blank"
                      href="#"
                      ><i class="feather-map"></i> </a
                    ><span class="text-muted" style="font-size:12px;">{{
                      restaurant.address
                    }}</span></a
                  >
                </li>
              </ul>
            </aside>
            <aside class="col-sm-3 col-md-3 text-white">
              <h6 class="title">Horaires</h6>
              <ul class="list-unstyled hov_footer">
                <li v-for="(hour, index) in restaurant.hours" :key="index">
                  <a href="" class="text-muted"
                    >{{ hour.title }} : {{ hour.value }}</a
                  >
                </li>
              </ul>
            </aside>
          </div>
          <!-- row.// -->
        </section>
        <!-- footer-top.// -->
      </div>
      <!-- //container -->
      <section class="footer-copyright border-top py-3 bg-light">
        <div class="container d-flex align-items-center justify-content-center">
          <p class="mb-0">© 2021 monresto.menu All rights reserved</p>
        </div>
      </section>
    </footer>
    <div
      class="osahan-menu-fotter fixed-bottom bg-white px-3 py-2 text-center d-none"
    >
      <div class="row">
        <div class="col">
          <a
            href="#"
            class="text-dark small font-weight-bold text-decoration-none"
          >
            <p class="h4 m-0"><i class="feather-home"></i></p>
            Accueil
          </a>
        </div>

        <div class="col bg-white rounded-circle mt-n4 px-3 py-2">
          <div class="bg-danger rounded-circle mt-n0 shadow">
            <a
              href="#"
              class="text-white small font-weight-bold text-decoration-none"
            >
              <i class="feather-shopping-cart"></i>
              <span class="countItemsMobile">0</span>
            </a>
          </div>
        </div>

        <div class="col selected">
          <a
            href="#"
            class="text-danger small font-weight-bold text-decoration-none"
          >
            <p class="h4 m-0"><i class="feather-map-pin text-danger"></i></p>
            Tendance
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["restaurant", "smaler", "changeName", "currentLang"],

  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>
<style></style>
